import { ISpcTheme } from '../../../../common/theme/ISpcTheme';
import { makeStyles } from '@material-ui/core/styles';

export type ActionButtonsClasses =
  | 'container'
  | 'item'
  | 'itemLabel'
  | 'saveButton'
  | 'continueButton'
  | 'enquireButton'
  | 'submitButton'
  | 'submitButtonLabel'
  | 'circularProgress'
  | 'buttonsWrapper'
  | 'gridContainer';

const actionButtonsStyles = makeStyles<ISpcTheme, ActionButtonsClasses>(
  theme => ({
    container: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-start',

      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: 'fit-content',
      },
    },
    gridContainer: {},
    item: {
      padding: '0 8px',

      [theme.breakpoints.down('md')]: {
        padding: '8px 0',
      },
    },
    itemLabel: {
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: '22px',
      textTransform: 'uppercase',
    },
    saveButton: {},
    continueButton: {},
    enquireButton: {},
    submitButton: {},
    submitButtonLabel: {},
    circularProgress: {
      position: 'relative',
      top: '3px',
      marginRight: '5px',
    },
    buttonsWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
  { name: 'GqlCustomise_ActionButtons' },
);

export default actionButtonsStyles;
